import React from "react";

import Icon from "@mdi/react";
import classNames from "classnames";

import FieldContainer from "./FieldContainer";

import type { JSX } from "react";

interface IReadOnlyField {
  label: string;
  value?: string;
  isUpperCase?: boolean;
  icon?: string;
  rotateIcon?: number;
}

function ReadOnlyField({
  label,
  value,
  isUpperCase,
  icon,
  rotateIcon,
}: IReadOnlyField): JSX.Element {
  const valueClassNames = classNames("flex items-center", {
    uppercase: isUpperCase,
  });
  return (
    <FieldContainer>
      <div className="flex shrink-0 grow-0 basis-1/3 flex-col justify-center">
        <span className="font-semibold whitespace-nowrap">{label}</span>
      </div>
      {icon ? <Icon path={icon} rotate={rotateIcon} size={1.25} /> : null}
      <span className={valueClassNames}>{value}</span>
    </FieldContainer>
  );
}

export default ReadOnlyField;
